@if (chips.length) {
  <div class="analyst-sources">
    <span class="sources-title">{{ 'Sources' | translate }}</span>
    <ol #sourcesList class="sources-list" [class.measuring]="layoutPending">
      @for (chip of chips; track trackByIndex($index)) {
        <li class="source-chip" [class.chip-hidden]="!expanded && !layoutPending && $index >= visibleCount"
          [class.ringed]="$index === ringedIndex">
          <a [href]="chip.citation.route" [title]="chip.fullLabel"
          (click)="onSourceClick($event, chip.citation)">{{ chip.label }}</a>
        </li>
      }
      @if (layoutPending || hiddenCount > 0) {
        <li class="sources-toggle">
          <button type="button" (click)="toggleExpanded()">{{ (expanded && !layoutPending ? 'Show less' : '+{{count}} more') | translate: { count: layoutPending ? chips.length : hiddenCount } }}</button>
        </li>
      }
    </ol>
  </div>
}
